<template>
  <div class="wg-row wg-xs-12">
    <!-- LOADING MODAL -->
    <wg-modal :simple="true" :width="'200px'" v-if="loading">
      <template slot="body">
        <div
          class="wg-row com-anm22-app-text-l"
          style="justify-content:center;"
        >
          {{ $anm22.strLang(lang, "Saving...", "Salvataggio in corso...") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <vue-simple-spinner
            size="medium"
            :line-fg-color="appColor"
          ></vue-simple-spinner>
        </div>
      </template>
    </wg-modal>
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isStart"
          :from="project.startDate"
          @customFunction="setStart"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="
            project.endDate != ''
              ? project.endDate
              : $moment.utc($moment()).unix()
          "
          @customFunction="setEnd"
        ></world-date-picker>
      </div>
    </wg-modal>
    <wg-modal v-if="showDeleteModal" @closeModal="showDeleteModal = false">
      <div slot="body">
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Delete project?", "Cancellare progetto?") }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-xxl" style="color:red;">
          {{
            $anm22.strLang(
              lang,
              "Data cannot be restored afterwards.",
              "I dati non potranno essere ripristinati in seguito."
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Yes', 'Sì')"
            @click="deleteProject"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small"
            :value="$anm22.strLang(lang, 'No', 'No')"
            @click="showDeleteModal = false"
          />
        </div>
      </div>
    </wg-modal>
    <div class="wg-col wg-xs-12 wg-lg-7">
      <h1 class="com-anm22-page-title">
        {{ title }}
      </h1>
      <!-- Se ho aggiunto un nuovo progetto senza selezionare alcun work prima della creazione, devo scegliere -->
      <template v-if="workId === 'my'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "Company", "Azienda") }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model="workSelect">
          <option
            v-for="(work, index) in worksCanAdd"
            :key="'work' + index"
            :value="work.idWorldWork"
          >
            {{ work.name }}
          </option>
        </select>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Status", "Stato") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <select class="com-anm22-app-select" v-model="projectStatus">
        <option
          v-for="(obj, index) in projectStatuses"
          :key="'status' + index"
          :value="obj.typeClass"
        >
          {{ obj[lang] }}
        </option>
      </select>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <input
          id="template"
          type="checkbox"
          :value="1"
          style="display:none;"
          v-model="project.template"
        />
        <label class="label-input-radio" for="template">
          {{ project.template ? "✔" : "" }}
        </label>
        <div class="com-anm22-app-text-l" style="margin-left:10px;">
          Template
        </div>
        <div style="position:relative;">
          <img
            @click="showHelp = !showHelp"
            class="com-anm22-app-img-s"
            style="margin-left:5px;opacity:0.6;cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('helpIcon')"
          />
          <world-help-label
            v-if="showHelp"
            :position="'right'"
            @closeLabel="showHelp = false"
            :text="'Spunta la check per creare un nuovo template di progetto'"
          ></world-help-label>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Category", "Categoria") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <select class="com-anm22-app-select" v-model="project.category">
        <option :value="0" default>{{
          $anm22.strLang(lang, "None", "Nessuna")
        }}</option>
        <option
          v-for="(pc, index) in projectCategories"
          :key="'pc' + index"
          :value="pc.idWorldProjectCategory"
        >
          {{ pc.name }}
        </option>
      </select>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Name", "Nome") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <input
        class="com-anm22-app-input-text"
        :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
        type="text"
        value=""
        v-model="project.name"
      />
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- INTEGRARE LA POSSIBILITA' O MENO DI MODIFICARE IL CODICE DI PROGETTO MANUALMENTE -->
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Project Code", "Codice progetto") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <input
        :disabled="!canEditProjectCode"
        class="com-anm22-app-input-text"
        :placeholder="$anm22.strLang(lang, 'Code', 'Codice')"
        type="text"
        v-model="project.projectId"
      />
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Description", "Descrizione") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <input
        class="com-anm22-app-input-text"
        :placeholder="$anm22.strLang(lang, 'Description', 'Descrizione')"
        type="text"
        v-model="project.description"
      />
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "Start date", "Data d'inizio") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12">
          <div
            @click="
              openPicker = !openPicker;
              isStart = true;
            "
            :class="['input-date-picker-label']"
          >
            {{ $moment(startDate).format("DD-MM-YYYY") }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, "End date", "Data di consegna") }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12">
          <div
            @click="
              openPicker = !openPicker;
              isStart = false;
            "
            :class="['input-date-picker-label']"
            style="display:inline-block;vertical-align:middle;"
          >
            {{ endDate != "" ? $moment(endDate).format("DD-MM-YYYY") : "-" }}
          </div>
          <img
            v-if="endDate != ''"
            class="com-anm22-app-img-fixed-height-s reset-date"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            @click="resetEndDate()"
          />
        </div>
      </div>
      <!-- Queste sezioni vengono mostrate in caso di creazione da 0 o di modifica -->
      <template v-if="mode !== 'copy'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "Customer order number",
              "Numero ordine cliente"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
          type="text"
          v-model="project.orderNumber"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "Customer project code",
              "Codice progetto cliente"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          :placeholder="$anm22.strLang(lang, 'Code', 'Codice')"
          type="text"
          v-model="project.customerProjectId"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "Customer contact person",
              "Persona di riferimento cliente"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          :placeholder="$anm22.strLang(lang, 'Referent', 'Referente')"
          type="text"
          v-model="project.customerReference"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "Intermediary contact person",
              "Persona di riferimento committente"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          :placeholder="$anm22.strLang(lang, 'Referent', 'Referente')"
          type="text"
          v-model="project.intermediaryReference"
        />
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <input
          type="button"
          :value="
            mode === 'edit'
              ? $anm22.strLang(lang, 'Save', 'Salva')
              : $anm22.strLang(lang, 'Create', 'Crea')
          "
          @click="saveProject"
        />
        <input
          v-if="canDelete"
          type="button"
          class="com-anm22-button-red"
          style="margin-left:10px;"
          :value="$anm22.strLang(lang, 'Delete', 'Cancella')"
          @click="showDeleteModal = true"
        />
      </div>
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('edit')" />
      <div v-if="mode === 'edit'">
        <strong>{{
          $anm22.strLang(lang, "Edit project details", "Modifica dati progetto")
        }}</strong
        ><br />
        {{
          $anm22.strLang(lang, "", "Aggiorna i dati principali del progetto.")
        }}
      </div>
      <div v-else>
        <strong>{{
          $anm22.strLang(
            lang,
            "Enter project details",
            "Inserisci dati progetto"
          )
        }}</strong
        ><br />
        {{
          $anm22.strLang(
            lang,
            "",
            "Descrivi il progetto. Puoi inserire i dati anche in un secondo momento."
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WorldDatePicker from "../../../../../../world/spa/components/WorldDatePicker.vue";
import WorldHelpLabel from "../../../../../../world/spa/components/WorldHelpLabel.vue";

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      openPicker: false,
      showHelp: false,
      isStart: false,
      mode: this.data.mode,
      project: { ...this.data.project },
      workId: this.data.workId,
      loading: false,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      appColor: (state) => state.config.appColor,
    }),
    userPermission() {
      return (
        this.$store.getters["employments/getPermByProject"](this.project) || 10
      );
    },
    projectCategories() {
      if (this.project.developers.length > 0) {
        return this.project.developers.reduce(
          (result, w) =>
            result.concat(
              this.$store.getters["projectCategories/getByWork"](w)
            ),
          []
        );
      } else {
        return this.workId
          ? this.$store.getters["projectCategories/getByWork"](this.workId)
          : [];
      }
    },
    projectStatuses() {
      if (this.mode === "edit" && this.project.developers) {
        const licenses = this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        )
          .filter((e) => this.project.developers.includes(e.work))
          .map((e) => this.$store.getters["licenses/getByWork"](e.work))
          .filter(
            (l) =>
              l &&
              l.config &&
              l.config.tasks &&
              l.config.tasks.project &&
              l.config.tasks.project["allowed-statuses"]
          );
        if (licenses && licenses.length > 0) {
          return Array.from(
            new Set(
              licenses.reduce((res, l) => {
                return res.concat(
                  this.$anm22[l.config.tasks.project["allowed-statuses"]](this)
                );
              }, [])
            )
          );
        }
      }
      return [6, 1, 2, 3, 4, 5].map((s) =>
        this.$anm22.tableClasses.projectStatus().getById(s)
      );
    },
    title() {
      switch (this.mode) {
        case "new":
          return this.$anm22.strLang(
            this.lang,
            "New project",
            "Nuovo progetto"
          );
          break;
        case "copy":
          return this.$anm22.strLang(
            this.lang,
            "Copy project",
            "Copia progetto"
          );
          break;
        case "edit":
          return this.$anm22.strLang(
            this.lang,
            "Edit project",
            "Modifica progetto"
          );
          break;
      }
    },
    projectStatus: {
      get() {
        return this.project.status;
      },
      set(newVal) {
        this.project.status = newVal;
        if (this.mode === "edit") {
          this.saveProject();
        }
      },
    },
    worksCanAdd() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => {
          const l = this.$store.getters["licenses/getByWork"](e.work);
          if (
            l &&
            l.config.tasks &&
            l.config.tasks.project &&
            l.config.tasks.project["add-rules"]
          ) {
            return this.$anm22[l.config.tasks.project["add-rules"]](this);
          } else {
            const permission = e.permission;
            const customerManager = e.clients.reduce(
              (res, c) => res || c.isManager,
              false
            );
            return permission <= 3 || customerManager;
          }
        })
        .map((e) => this.$store.getters["works/get"](e.work));
    },
    workSelect: {
      get() {
        if (this.workId !== "my") {
          return this.workId;
        } else {
          if (this.worksCanAdd[0].idWorldWork == 474) {
            this.setCode(this.worksCanAdd[0].idWorldWork);
          }
          return this.worksCanAdd[0].idWorldWork;
        }
      },
      set(newVal) {
        this.workId = newVal;
        this.setCode(newVal);
      },
    },
    startDate: {
      get() {
        return this.$moment
          .unix(this.project.startDate)
          .utc()
          .format("YYYY-MM-DD");
      },
      set: _.debounce(function(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.project.startDate = "";
        } else if (ts) {
          this.project.startDate = ts;
        }
      }, 100),
    },
    endDate: {
      get() {
        if (this.project.endDate !== "") {
          return this.$moment
            .unix(this.project.endDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return "";
        }
      },
      set: _.debounce(function(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.project.endDate = "";
        } else if (ts) {
          this.project.endDate = ts;
        }
      }, 100),
    },
    // se il parametro di configurazione è false anche solo per una azienda di progetto, allora
    // non permetto la cancellazione, altrimenti se il valore è numerico lo confronto con il mio permesso.
    // se invece è una stringa (nello specifico 'custom') chiamo la funzione custom che restituisce un booleano.
    canDelete() {
      if (this.mode === "edit" && this.project.developers) {
        const licenses = this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        )
          .filter((e) => this.project.developers.includes(e.work))
          .map((e) => this.$store.getters["licenses/getByWork"](e.work))
          .filter((l) => l);
        return licenses.reduce((res, license) => {
          if (
            license.config &&
            license.config["tasks"]["project"] &&
            license.config["tasks"]["project"]["delete"]
          ) {
            if (
              typeof license.config["tasks"]["project"]["delete"] !== "string"
            ) {
              return (
                res &&
                this.userPermission <=
                  license.config["tasks"]["project"]["delete"]
              );
            } else {
              return (
                res &&
                license.config["tasks"]["project"]["delete-rules"] &&
                this.$anm22[license.config["tasks"]["project"]["delete-rules"]](
                  this,
                  this.project
                )
              );
            }
          } else {
            return false;
          }
        }, true);
      } else {
        return false;
      }
    },
    canEditProjectCode() {
      let licenses = [];
      if (this.mode === "edit" && this.project.developers) {
        licenses = this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        )
          .filter((e) => this.project.developers.includes(e.work))
          .map((e) => this.$store.getters["licenses/getByWork"](e.work))
          .filter((l) => l);
      } else {
        licenses.push(
          this.$store.getters["licenses/getByWork"](this.workSelect)
        );
      }
      return licenses.reduce((res, license) => {
        return (
          res &&
          license &&
          license.config.tasks.project &&
          license.config.tasks.project["project-code-edit"]
        );
      }, true);
    },
  },
  methods: {
    updateVircosDoc(project) {
      this.$http
        .get("vircos?projectId=" + project.idWorldProject)
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          response.data.models.map((model) =>
            this.$vlf("vircos-models-base").setItem(
              String(model.idVircosModelsBase),
              model
            )
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async setCode(workId) {
      if (workId == 474) {
        await this.$http.get("link/getProjectCodePreview").then((response) => {
          this.project.projectId = response.data.projectId;
        });
      } else {
        this.project.projectId = "";
      }
    },
    addCustomer(customerId, projectId) {
      this.$http
        .post(
          "/project/addCustomer",
          {
            projectId: projectId,
            contactId: customerId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact],
            }),
          ]);
        })
        .catch((error) => console.log(error));
    },
    setStart(newDate) {
      this.startDate = newDate;
      this.openPicker = false;
    },
    setEnd(newDate) {
      this.endDate = newDate;
      this.openPicker = false;
    },
    resetEndDate() {
      this.project.endDate = "";
    },
    goToNextStep(projectId) {
      //Da fare, si prosegue a seconda di quanto specificato nella configurazione di licenza
      const license = this.$store.getters["licenses/getByWork"](
        this.workSelect
      );
      if (
        license &&
        license.config["create-project-flow"] &&
        license.config["create-project-flow"]["after-creation-step"] &&
        license.config["create-project-flow"]["after-creation-step"] == "open"
      ) {
        this.$router.push({
          path: "/project/" + projectId,
        });
      } else {
        this.$router.push({
          path: "/project/edit/" + projectId,
          query: {
            page: "customers",
          },
        });
      }
    },
    /*
      Viene usato in caso di salvataggio offline per sostituire il server nella costruzione dell'oggetto completo
    */
    buildProjectOffline() {
      this.project.creationDate = this.$moment().unix();
      this.project.users = [this.user.idWorldUser];
      this.project.developers = [this.workSelect];
      this.project.customers = [];
      this.project.events = [];
      this.project.template = false;
      this.project.links = [];
      this.project.tags = [];
      /* Genero un id locale temporaneo */
      this.project.dbKey = this.project.idWorldProject = this.$anm22.genLocalId();
    },
    saveProject() {
      this.loading = true;
      /* Salvataggio delle info di progetto / creazione */
      switch (this.mode) {
        case "new":
          this.buildProjectOffline();
          //Se è una creazione da contacts allora aggiungo il customer al progetto
          if (this.data.customerId) {
            this.project.customers.push(this.data.customerId);
          }
          this.$http
            .post(
              "project/new/",
              {
                project: this.project,
                work: this.workSelect,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              this.loading = false;
              if (this.data.customerId) {
                this.addCustomer(
                  this.data.customerId,
                  response.data.projects[0].idWorldProject
                );
              }
              if (response.data.projects[0].developers.includes(16)) {
                this.updateVircosDoc(response.data.projects[0]);
              }
              this.goToNextStep(response.data.projects[0].idWorldProject);
            })
            .catch((error) => {
              /* Preparazione al salvataggio offline */
              /* Salvo l'oggetto nel db */
              console.log("saving offline");
              Promise.all([
                this.$store.dispatch("projects/update", {
                  vlf: this.$vlf("projects"),
                  objs: [this.project],
                }),
                /* Sync update */
                this.$store.dispatch("offline/saveSyncTuple", {
                  _vue: this,
                  _class: "WorldProject",
                  _table: "projects",
                  mode: "new",
                  type: "obj",
                  obj: this.project,
                }),
                // this.$anm22.saveSyncTuple(this, 'WorldProject', 'new', this.project)
              ])
                .then((result) => {
                  this.loading = false;
                  this.goToNextStep(this.project.idWorldProject);
                })
                .catch((error) => {
                  console.log(error);
                });
            });
          break;
        case "copy":
          this.buildProjectOffline();
          /* Copia dati da progetto */
          const projectToCopy = this.$store.getters["projects/get"](
            this.data.toCopy
          );
          this.project.developers = projectToCopy.developers;
          this.project.users = projectToCopy.users;
          this.project.tags = projectToCopy.tags;
          /* Se non era parte dello staff del progetto da copiare, aggiungo nuovamente l'utente corrente */
          if (-1 === this.project.users.indexOf(this.user.idWorldUser)) {
            this.project.users.push(this.user.idWorldUser);
          }
          this.project.customers = projectToCopy.customers;
          //Se è una creazione da contacts allora aggiungo il customer al progetto se non è gia presente
          if (
            this.data.customerId &&
            !this.project.customers.includes(this.data.customerId)
          ) {
            this.project.customers.push(this.data.customerId);
          }
          /* Creazione dei task in copia */
          const newTasks = []; // Offline
          const syncTasksRef = {}; // Salvataggi id locali per riferimento lato server
          const tasks = this.$store.getters["tasks/getByProject"](
            projectToCopy.idWorldProject
          );
          tasks.forEach((t) => {
            /* Offline */
            let newTask = { ...t };
            newTask.idWorldTask = newTask.dbKey = this.$anm22.genLocalId();
            newTask.project = this.project.idWorldProject;
            newTasks.push(newTask);
            /* Online */
            syncTasksRef[t.idWorldTask] = newTask.idWorldTask;
          });
          this.$http
            .post(
              "/project/copy/",
              {
                project: this.project,
                syncTasksRef,
                toCopy: this.data.toCopy,
                copyConditions: this.data.copyConditions,
                work: this.workSelect,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              this.loading = false;
              if (
                this.data.customerId &&
                !response.data.projects[0].customers.includes(
                  this.data.customerId
                )
              ) {
                this.addCustomer(
                  this.data.customerId,
                  response.data.projects[0].idWorldProject
                );
              }
              if (response.data.projects[0].developers.includes(16)) {
                this.updateVircosDoc(response.data.projects[0]);
              }
              this.goToNextStep(response.data.projects[0].idWorldProject);
            })
            .catch((error) => {
              /* Preparazione al salvataggio offline */
              /* Salvo l'oggetto nel db */
              Promise.all([
                this.$store.dispatch("projects/update", {
                  vlf: this.$vlf("projects"),
                  objs: [this.project],
                }),
                this.$store.dispatch("tasks/update", {
                  vlf: this.$vlf("tasks"),
                  objs: newTasks,
                }),
                this.$store.dispatch("offline/saveSyncTuple", {
                  _vue: this,
                  _class: "WorldProject",
                  _table: "projects",
                  mode: "new",
                  type: "obj",
                  obj: this.project,
                }),
                // this.$anm22.saveSyncTuple(this, 'WorldProject', 'new', this.project),
                newTasks.map((t) => {
                  this.$store.dispatch("offline/saveSyncTuple", {
                    _vue: this,
                    _class: "WorldTask",
                    _table: "tasks",
                    mode: "new",
                    type: "obj",
                    obj: t,
                  });
                  // return this.$anm22.saveSyncTuple(this, 'WorldTask', 'new', t)
                }),
              ])
                .then((result) => {
                  this.loading = false;
                  this.goToNextStep(this.project.idWorldProject);
                })
                .catch((error) => {
                  console.log(error);
                });
            });
          break;
        case "edit":
          this.$http
            .post(
              "/project/edit/",
              {
                project: this.project,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              //Salvo con localForage
              this.$store
                .dispatch("projects/update", {
                  vlf: this.$vlf("projects"),
                  objs: response.data.projects,
                })
                .then(() => {
                  //Per sicurezza aggiorno la copia locale del progetto con quanto salvato nello stato
                  this.project = {
                    ...this.$store.getters["projects/get"](
                      this.project.idWorldProject
                    ),
                  };
                  this.loading = false;
                  this.$Progress.finish();
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Update successful",
                      "Salvataggio avvenuto con successo"
                    ),
                    type: "suggestion",
                  });
                  if (this.project.developers.includes(16)) {
                    this.updateVircosDoc(this.project);
                  }
                })
                .catch((error) => console.log(error));
            })
            .catch((error) => {
              /* Salvo l'oggetto nel db */
              Promise.all([
                this.$store.dispatch("projects/update", {
                  vlf: this.$vlf("projects"),
                  objs: [this.project],
                }),
                this.$store.dispatch("offline/saveSyncTuple", {
                  _vue: this,
                  _class: "WorldProject",
                  _table: "projects",
                  mode: "edit",
                  type: "obj",
                  obj: this.project,
                }),
                // this.$anm22.saveSyncTuple(this, 'WorldProject', 'edit', this.project)
              ])
                .then((result) => {
                  //Per sicurezza aggiorno la copia locale del progetto con quanto salvato nello stato
                  this.project = {
                    ...this.$store.getters["projects/get"](
                      this.project.idWorldProject
                    ),
                  };
                  this.loading = false;
                  this.$Progress.finish();
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Update successful",
                      "Salvataggio avvenuto con successo"
                    ),
                    type: "suggestion",
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            });
          break;
      }
    },
    async deleteProject() {
      const response = await this.$http.post(
        "project/delete",
        {
          projectId: this.project.idWorldProject,
        },
        {
          withCredentials: true,
        }
      );
      this.$router.push("/");
    },
  },
  components: {
    WorldDatePicker,
    "vue-simple-spinner": Spinner,
    WorldHelpLabel,
  },
  created() {
    this.$http
      .get("project/settings")
      .then((response) => {
        Promise.all([
          this.$store.dispatch("projectCategories/update", {
            vlf: this.$vlf("projectsCategories"),
            objs: response.data.projectCategories,
          }),
        ])
          .then((result) => {})
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => console.log(error));
  },
};
</script>

<style lang="scss" scoped>
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.reset-date {
  opacity: 0.8;
  cursor: pointer;
  width: 11px;
  margin-left: -20px;
  display: inline-block;
  vertical-align: middle;
}
.icon-picker {
  cursor: pointer;
  opacity: 0.7;
}
</style>
